import { Shield, CheckCircle2, Globe, Zap } from 'lucide-react'
import { Badge } from './ui/badge';

const TrustSignals = () => {
    const integrations = [
        { name: "ERP Integration", icon: Zap },
        { name: "GIS Compatible", icon: Globe },
        { name: "BIM Ready", icon: CheckCircle2 },
        { name: "CAD Support", icon: Shield },
    ];

    const compliance = [
        //{ name: "ISO 27001", status: "Aligned", color: "default" as const },
        //{ name: "SOC 2", status: "In Progress", color: "secondary" as const },
        { name: "GDPR", status: "Compliant", color: "default" as const },
        { name: "Australian Law", status: "Governed", color: "default" as const },
    ];

    return (
        <section className="py-16 inset-shadow-2xl bg-gradient-to-br from-home-primary/10 via-home-primary/5 to-home-background border-y-2 border-home-primary/20">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-home-foreground mb-2">
                    Trusted by Infrastructure Leaders
                </h3>
                <p className="text-muted-foreground">
                    Enterprise-grade security and seamless integration with your existing systems
                </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    <div className="rounded-lg border bg-home-card text-home-card-foreground shadow-sm p-6 transition-all hover:shadow-lg hover:shadow-home-primary/10 hover:border-home-primary/30">
                        <h4 className="font-semibold text-home-foreground mb-4 flex items-center gap-2">
                            <Zap className="w-5 h-5 text-home-primary" />
                            Integration Partners
                        </h4>
                        <div className="grid grid-cols-2 gap-3">
                            {integrations.map((integration) => (
                                <div key={integration.name} className="flex items-center gap-2 p-3 rounded-lg bg-home-primary/5 hover:bg-home-primary/10 transition-colors">
                                    <integration.icon className="w-4 h-4 text-home-primary" />
                                    <span className="text-sm text-home-foreground">{integration.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="rounded-lg border bg-home-card text-home-card-foreground shadow-sm p-6 transition-all hover:shadow-lg hover:shadow-home-primary/10 hover:border-home-primary/30">
                        <h4 className="font-semibold text-home-foreground mb-4 flex items-center gap-2">
                            <Shield className="w-5 h-5 text-primary" />
                            Security & Compliance
                        </h4>
                        <div className="flex flex-wrap gap-2">
                            {compliance.map((item) => (
                                <Badge key={item.name} variant={item.color} className="px-3 py-1">
                                    <CheckCircle2 className="w-3 h-3 mr-1" />
                                    {item.name}: {item.status}
                                </Badge>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            </section>
    )
}

export {
    TrustSignals
}